// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1RpZ7","consentsList":"PatientConsents_consentsList__1KrO0","consentsListEmpty":"PatientConsents_consentsListEmpty__ndurr"};